import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import ServicesIndex from "@/pages/ServicesIndex";
import ZonesIndex from "@/pages/ZonesIndex";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesIndex />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/zones" element={<ZonesIndex />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          {/* SEO-friendly city URLs at root, e.g. /degraissage-hotte-melun */}
          <Route path="/:slug" element={<CityPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
